import { render, staticRenderFns } from "./multipleChoice.vue?vue&type=template&id=68ea8f4e&scoped=true&"
import script from "./multipleChoice.vue?vue&type=script&lang=js&"
export * from "./multipleChoice.vue?vue&type=script&lang=js&"
import style0 from "./multipleChoice.vue?vue&type=style&index=0&id=68ea8f4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea8f4e",
  null
  
)

export default component.exports